<div class="eq-layout">
  <app-barra-superior />
  <div class="eq-layout__cuerpo">
    <app-menu-lateral />
    <main class="eq-layout__contenido">
      @if (servicioCargando.cargandoModulo()) {
        <div class="eq-cargando eq-cargando--6" role="status">
          <p-progress-spinner strokeWidth="4" />
          <span class="eq-cargando__texto">{{ servicioCargando.mensaje() }}</span>
        </div>
      }
      <router-outlet />
    </main>
  </div>
</div>
